<script>
import { mapGetters } from 'vuex';
import { shouldBeUrl } from 'shared/helpers/Validators';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';
import { getChannelSvgUrlForInbox } from 'dashboard/components-next/icon/channelSvgUrls';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import SettingsAccordion from 'dashboard/components-next/Settings/SettingsAccordion.vue';
import WidgetCustomizationSection from 'dashboard/components-next/Settings/WidgetCustomizationSection.vue';
import inboxMixin from 'shared/mixins/inboxMixin';
import FacebookReauthorize from './facebook/Reauthorize.vue';
import InstagramReauthorize from './channels/instagram/Reauthorize.vue';
import TiktokReauthorize from './channels/tiktok/Reauthorize.vue';
import DuplicateInboxBanner from './channels/instagram/DuplicateInboxBanner.vue';
import MicrosoftReauthorize from './channels/microsoft/Reauthorize.vue';
import GoogleReauthorize from './channels/google/Reauthorize.vue';
import WhatsappReauthorize from './channels/whatsapp/Reauthorize.vue';
import InboxHealthAPI from 'dashboard/api/inboxHealth';
import PreChatFormSettings from './PreChatForm/Settings.vue';
import GreetingsEditor from 'shared/components/GreetingsEditor.vue';
import ConfigurationPage from './settingsPage/ConfigurationPage.vue';
import WebWidgetConfigurationPage from './settingsPage/WebWidgetConfigurationPage.vue';
import BrowserWhatsappSessionPage from './settingsPage/BrowserWhatsappSessionPage.vue';
import AccountHealth from './components/AccountHealth.vue';
import SenderNameExamplePreview from './components/SenderNameExamplePreview.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SpinnerLoader from 'dashboard/components-next/spinner/Spinner.vue';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import Editor from 'dashboard/components-next/Editor/Editor.vue';
import ColorPicker from 'dashboard/components-next/colorpicker/ColorPicker.vue';
import FormInput from 'dashboard/components-next/input/Input.vue';
import SelectInput from 'dashboard/components-next/select/Select.vue';
import Widget from 'dashboard/modules/widget-preview/components/Widget.vue';
import AccessToken from 'dashboard/routes/dashboard/settings/profile/AccessToken.vue';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import InboxSettingsInboxPicker from './components/InboxSettingsInboxPicker.vue';
import InboxChannelConfigurationIdentity from './components/InboxChannelConfigurationIdentity.vue';
import InboxTroubleshootPage from './components/InboxTroubleshootPage.vue';
import InboxDangerZone from './components/InboxDangerZone.vue';
import InboxConfigurationSaveBar from './components/InboxConfigurationSaveBar.vue';
import InboxMessageTemplatesTab from './InboxMessageTemplatesTab.vue';
import InboxBusinessHoursTab from './InboxBusinessHoursTab.vue';
import InboxSettingsNavItem from 'dashboard/components-next/Settings/InboxSettingsNavItem.vue';
import InboxSettingsPageHeader from 'dashboard/components-next/Settings/InboxSettingsPageHeader.vue';
import WebWidgetLauncherStylePicker from './components/WebWidgetLauncherStylePicker.vue';
import WebWidgetHeaderLogoPicker from './components/WebWidgetHeaderLogoPicker.vue';
import ConfirmationModal from 'dashboard/components/widgets/modal/ConfirmationModal.vue';
import {
  CUSTOM_LAUNCHER_STYLE_ID,
  bubbleTypeFromPopupMessage,
} from 'dashboard/constants/webWidgetLauncherStyles';
import { WIDGET_SPACING_OPTIONS } from 'shared/constants/webWidgetSpacing';
import { getPreChatFields } from 'dashboard/helper/preChat';

const DEFAULT_OPEN_WIDGET_SECTION = 'display';

export default {
  components: {
    BrowserWhatsappSessionPage,
    ConfigurationPage,
    WebWidgetConfigurationPage,
    FacebookReauthorize,
    GreetingsEditor,
    PreChatFormSettings,
    SettingsToggleSection,
    SettingsFieldSection,
    SettingsAccordion,
    SenderNameExamplePreview,
    MicrosoftReauthorize,
    GoogleReauthorize,
    NextButton,
    SpinnerLoader,
    InstagramReauthorize,
    TiktokReauthorize,
    WhatsappReauthorize,
    DuplicateInboxBanner,
    Editor,
    ColorPicker,
    FormInput,
    SelectInput,
    AccountHealth,
    Widget,
    AccessToken,
    Icon,
    InboxSettingsInboxPicker,
    InboxChannelConfigurationIdentity,
    InboxTroubleshootPage,
    InboxMessageTemplatesTab,
    WebWidgetLauncherStylePicker,
    WebWidgetHeaderLogoPicker,
    ConfirmationModal,
    InboxSettingsNavItem,
    InboxSettingsPageHeader,
    WidgetCustomizationSection,
    InboxDangerZone,
    InboxConfigurationSaveBar,
    InboxBusinessHoursTab,
  },
  mixins: [inboxMixin],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      greetingEnabled: true,
      greetingMessage: '',
      emailCollectEnabled: false,
      senderNameType: 'friendly',
      businessName: '',
      allowMessagesAfterResolved: true,
      continuityViaEmail: true,
      selectedInboxName: '',
      channelWebsiteUrl: '',
      webhookUrl: '',
      channelWelcomeTitle: '',
      channelWelcomeTagline: '',
      channelChatInputText: '',
      selectedFeatureFlags: [],
      replyTime: '',
      selectedTabIndex: 0,
      showBusinessNameInput: false,
      healthData: null,
      isLoadingHealth: false,
      healthError: null,
      isRegisteringWebhook: false,
      widgetBubblePosition: 'right',
      widgetVerticalSpacing: 'standard',
      widgetHorizontalSpacing: 'standard',
      widgetBubbleLauncherTitle: '',
      widgetSize: 'medium',
      widgetDisplayOption: 'mobile_and_desktop',
      bubbleIconStyle: '1',
      customIconPreview: null,
      customIconFile: null,
      headerLogoPreview: null,
      headerLogoFile: null,
      headerLogoRemoved: false,
      openWidgetSection: DEFAULT_OPEN_WIDGET_SECTION,
      savedWidgetCustomizationSnapshot: null,
      savedInboxSettingsSnapshot: null,
      webWidgetCanSave: false,
      webWidgetConfigurationLoading: false,
      beforeUnloadHandler: null,
      widgetPreviewPreChat: {
        enabled: false,
        message: '',
        fields: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      uiFlags: 'inboxes/getUIFlags',
    }),
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
    widgetBubbleType() {
      return bubbleTypeFromPopupMessage(this.widgetBubbleLauncherTitle);
    },
    widgetSpacingSelectOptions() {
      return WIDGET_SPACING_OPTIONS.map(value => ({
        value,
        label: this.$t(
          `INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POSITION_SETTINGS.SPACING_${value.toUpperCase()}`
        ),
      }));
    },
    configureChannelLabel() {
      if (!this.inbox?.channel_type) return this.inboxName;
      const { channel_type: type } = this.inbox;
      switch (type) {
        case INBOX_TYPES.FB:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_FACEBOOK');
        case INBOX_TYPES.WEB:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_WEB');
        case INBOX_TYPES.TWITTER:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_TWITTER');
        case INBOX_TYPES.TWILIO:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_TWILIO');
        case INBOX_TYPES.WHATSAPP:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_WHATSAPP');
        case INBOX_TYPES.WHATSAPP_BROWSER:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_WHATSAPP_BROWSER');
        case INBOX_TYPES.API:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_API');
        case INBOX_TYPES.EMAIL:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_EMAIL');
        case INBOX_TYPES.TELEGRAM:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_TELEGRAM');
        case INBOX_TYPES.LINE:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_LINE');
        case INBOX_TYPES.SMS:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_SMS');
        case INBOX_TYPES.INSTAGRAM:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_INSTAGRAM');
        case INBOX_TYPES.TIKTOK:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_TIKTOK');
        case INBOX_TYPES.VOICE:
          return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CHANNEL_VOICE');
        default:
          return this.inboxName;
      }
    },
    configureHeaderTitle() {
      if (this.selectedTabKey === 'message-templates') {
        return this.$t('INBOX_MGMT.MESSAGE_TEMPLATES_TAB.PAGE_HEADER');
      }
      if (this.selectedTabKey === 'business-hours') {
        return this.$t('INBOX_MGMT.BUSINESS_HOURS.PAGE_HEADER');
      }
      return this.$t('INBOX_MGMT.SETTINGS_LAYOUT.CONFIGURE_TITLE', {
        channel: this.configureChannelLabel,
      });
    },
    shouldShowWhatsAppConfiguration() {
      return this.isAWhatsAppCloudChannel;
    },
    shouldShowMessageTemplatesTab() {
      return (
        this.isAFacebookInbox ||
        this.isAnInstagramChannel ||
        this.isAWhatsAppChannel
      );
    },
    isBrowserWhatsappInbox() {
      return (
        this.inbox.channel_type === INBOX_TYPES.WHATSAPP_BROWSER ||
        (this.isAPIInbox && this.inbox.provider === 'waha_browser_whatsapp')
      );
    },
    whatsAppAPIProviderName() {
      if (this.isAWhatsAppCloudChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD');
      }
      if (this.is360DialogWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG');
      }
      if (this.isATwilioWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO');
      }
      return '';
    },
    tabs() {
      if (this.isAWebWidgetInbox) {
        const webWidgetTabs = [
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.WEB_WIDGET_CONFIGURATION'),
          },
          {
            key: 'business-hours',
            name: this.$t('INBOX_MGMT.TABS.BUSINESS_HOURS'),
          },
          {
            key: 'widget-customization',
            name: this.$t('INBOX_MGMT.TABS.WIDGET_CUSTOMIZATION'),
          },
        ];

        webWidgetTabs.push({
          key: 'troubleshoot',
          name: this.$t('INBOX_MGMT.TABS.TROUBLESHOOT'),
        });

        return webWidgetTabs;
      }

      let visibleToAllChannelTabs = [
        {
          key: 'inbox-settings',
          name: this.$t('INBOX_MGMT.TABS.SETTINGS'),
        },
        {
          key: 'business-hours',
          name: this.$t('INBOX_MGMT.TABS.BUSINESS_HOURS'),
        },
      ];

      if (
        this.isATwilioChannel ||
        this.isALineChannel ||
        this.isAPIInbox ||
        this.isBrowserWhatsappInbox ||
        this.isAVoiceChannel ||
        (this.isAnEmailChannel && !this.inbox.provider) ||
        this.shouldShowWhatsAppConfiguration ||
        this.isAFacebookInbox ||
        this.isAnInstagramChannel
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.CONFIGURATION'),
          },
        ];
      }

      if (this.shouldShowMessageTemplatesTab) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'message-templates',
            name: this.$t('INBOX_MGMT.TABS.MESSAGE_TEMPLATES'),
          },
        ];
      }

      if (this.shouldShowWhatsAppConfiguration) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'whatsapp-health',
            name: this.$t('INBOX_MGMT.TABS.ACCOUNT_HEALTH'),
          },
        ];
      }

      visibleToAllChannelTabs = [
        ...visibleToAllChannelTabs,
        {
          key: 'troubleshoot',
          name: this.$t('INBOX_MGMT.TABS.TROUBLESHOOT'),
        },
      ];

      return visibleToAllChannelTabs;
    },
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },
    widgetPreviewLogo() {
      if (this.isAWebWidgetInbox && this.inbox?.avatar_url) {
        return this.inbox.avatar_url;
      }
      return getChannelSvgUrlForInbox(this.inbox) || '';
    },
    widgetPreviewHeaderLogo() {
      if (this.headerLogoRemoved) return '';
      return this.headerLogoPreview || this.inbox?.avatar_url || '';
    },
    widgetLauncherCustomIconUrl() {
      if (this.bubbleIconStyle !== CUSTOM_LAUNCHER_STYLE_ID) return '';
      return this.customIconPreview || '';
    },
    bannerMaxWidth() {
      const fullWidthTabs = [
        'configuration',
        'inbox-settings',
        'business-hours',
        'troubleshoot',
      ];
      if (fullWidthTabs.includes(this.selectedTabKey)) return 'w-full';
      const wideIfWebWidget = ['widget-customization', 'message-templates'];
      if (wideIfWebWidget.includes(this.selectedTabKey)) {
        return this.isAWebWidgetInbox ? 'max-w-7xl' : 'max-w-4xl';
      }
      return 'max-w-7xl';
    },
    mainContentWrapClass() {
      const fullWidthTabs = [
        'configuration',
        'inbox-settings',
        'business-hours',
        'troubleshoot',
      ];
      if (
        (this.selectedTabKey === 'widget-customization' &&
          this.isAWebWidgetInbox) ||
        fullWidthTabs.includes(this.selectedTabKey)
      ) {
        return 'w-full py-6 md:py-8 px-4 md:px-6';
      }
      return 'max-w-7xl mx-auto w-full py-6 md:py-8';
    },
    inboxName() {
      if (this.isATwilioSMSChannel || this.isATwilioWhatsAppChannel) {
        return `${this.inbox.name} (${
          this.inbox.messaging_service_sid || this.inbox.phone_number
        })`;
      }
      if (this.isAWhatsAppChannel) {
        return `${this.inbox.name} (${this.inbox.phone_number})`;
      }
      if (this.isAnEmailChannel) {
        return `${this.inbox.name} (${this.inbox.email})`;
      }
      return this.inbox.name;
    },
    hasInboxConnectedBy() {
      return Boolean(this.inbox?.created_by_id);
    },
    inboxConnectedByUserLine() {
      if (!this.hasInboxConnectedBy) return '';

      return this.$t('INBOX_MGMT.SETTINGS_NAV.CONNECTED_BY_USER', {
        name: this.inbox.created_by_name,
        id: this.inbox.created_by_id,
      });
    },
    inboxNameLabel() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.LABEL');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL');
    },
    inboxNamePlaceHolder() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.PLACEHOLDER');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.PLACEHOLDER');
    },
    textAreaChannels() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox
      )
        return true;
      return false;
    },
    instagramUnauthorized() {
      return this.isAnInstagramChannel && this.inbox.reauthorization_required;
    },
    tiktokUnauthorized() {
      return this.isATiktokChannel && this.inbox.reauthorization_required;
    },
    // Check if a instagram inbox exists with the same instagram_id
    hasDuplicateInstagramInbox() {
      const instagramId = this.inbox.instagram_id;
      const instagramInbox =
        this.$store.getters['inboxes/getInstagramInboxByInstagramId'](
          instagramId
        );

      return this.inbox.channel_type === INBOX_TYPES.FB && instagramInbox;
    },
    microsoftUnauthorized() {
      return this.isAMicrosoftInbox && this.inbox.reauthorization_required;
    },
    facebookUnauthorized() {
      return this.isAFacebookInbox && this.inbox.reauthorization_required;
    },
    googleUnauthorized() {
      const isLegacyInbox = ['imap.gmail.com', 'imap.google.com'].includes(
        this.inbox.imap_address
      );

      return (
        (this.isAGoogleInbox || isLegacyInbox) &&
        this.inbox.reauthorization_required
      );
    },
    isEmbeddedSignupWhatsApp() {
      return this.inbox.provider_config?.source === 'embedded_signup';
    },
    whatsappUnauthorized() {
      return (
        this.isAWhatsAppCloudChannel &&
        this.isEmbeddedSignupWhatsApp &&
        this.inbox.reauthorization_required
      );
    },
    whatsappRegistrationIncomplete() {
      if (
        !this.healthData ||
        !this.isAWhatsAppCloudChannel ||
        !this.isEmbeddedSignupWhatsApp
      ) {
        return false;
      }

      return (
        this.healthData.platform_type === 'NOT_APPLICABLE' ||
        this.healthData.throughput?.level === 'NOT_APPLICABLE'
      );
    },
    widgetBuilderStorageKey() {
      return `${LOCAL_STORAGE_KEYS.WIDGET_BUILDER}${this.inbox.id}`;
    },
    hasWidgetCustomizationChanges() {
      if (!this.isAWebWidgetInbox || !this.savedWidgetCustomizationSnapshot) {
        return false;
      }

      return (
        JSON.stringify(this.getWidgetCustomizationSnapshot()) !==
        this.savedWidgetCustomizationSnapshot
      );
    },
    showConfigurationSaveBar() {
      if (
        this.selectedTabKey === 'inbox-settings' &&
        this.isBrowserWhatsappInbox
      ) {
        return false;
      }
      if (this.selectedTabKey === 'inbox-settings' && !this.isAWebWidgetInbox) {
        return true;
      }
      return this.selectedTabKey === 'configuration' && this.isAWebWidgetInbox;
    },
    hasInboxSettingsChanges() {
      if (!this.savedInboxSettingsSnapshot) return false;
      return (
        JSON.stringify(this.getInboxSettingsSnapshot()) !==
        this.savedInboxSettingsSnapshot
      );
    },
    configurationSaveDisabled() {
      if (this.selectedTabKey === 'configuration' && this.isAWebWidgetInbox) {
        return !this.webWidgetCanSave;
      }
      if (this.selectedTabKey === 'inbox-settings') {
        return this.v$.$invalid || !this.hasInboxSettingsChanges;
      }
      return true;
    },
    configurationSaveLoading() {
      if (this.selectedTabKey === 'configuration' && this.isAWebWidgetInbox) {
        return this.webWidgetConfigurationLoading;
      }
      return this.uiFlags.isUpdating;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'settings_inbox_show') {
        const inboxChanged = to.params.inboxId !== from.params.inboxId;
        const tabChanged = to.params.tab !== from.params.tab;
        if (inboxChanged) {
          this.syncInboxData();
        }
        if (inboxChanged || tabChanged) {
          this.setTabFromRouteParam();
        }
      }
    },
    selectedTabKey(tabKey) {
      if (tabKey === 'widget-customization' && this.isAWebWidgetInbox) {
        this.ensureWidgetSectionOpen();
      }
    },
    inbox: {
      handler(newInbox, oldInbox) {
        if (newInbox?.id !== oldInbox?.id) {
          this.openWidgetSection = DEFAULT_OPEN_WIDGET_SECTION;
          this.syncInboxData();
          this.fetchHealthData();
          this.$nextTick(() => {
            this.setTabFromRouteParam();
          });
        } else {
          this.selectedFeatureFlags = (
            newInbox?.selected_feature_flags || []
          ).filter(f => f !== 'use_inbox_avatar_for_bot');
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchSharedData();
    this.beforeUnloadHandler = event => {
      if (
        this.hasWidgetCustomizationChanges &&
        this.selectedTabKey === 'widget-customization'
      ) {
        event.preventDefault();
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeUnmount() {
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.selectedTabKey === 'widget-customization' &&
      this.hasWidgetCustomizationChanges
    ) {
      const confirmed = await this.confirmDiscardWidgetChanges();
      if (confirmed) {
        this.syncInboxData();
        next();
      } else {
        next(false);
      }
      return;
    }
    next();
  },
  async beforeRouteUpdate(to, from, next) {
    const inboxChanged = to.params.inboxId !== from.params.inboxId;
    const wasOnWidgetCustomization =
      from.params.tab === 'widget-customization' ||
      from.params.tab === 'pre-chat-form';
    const leavingWidgetCustomization =
      wasOnWidgetCustomization &&
      to.params.tab !== 'widget-customization' &&
      to.params.tab !== 'pre-chat-form';

    if (
      (inboxChanged || leavingWidgetCustomization) &&
      this.hasWidgetCustomizationChanges
    ) {
      const confirmed = await this.confirmDiscardWidgetChanges();
      if (confirmed) {
        this.syncInboxData();
        next();
      } else {
        next(false);
      }
      return;
    }
    next();
  },
  methods: {
    async copyWebhookSecret(value) {
      await copyTextToClipboard(value);
      useAlert(
        this.$t(
          'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.COPY_SUCCESS'
        )
      );
    },
    async resetWebhookSecret() {
      const response = await this.$store.dispatch(
        'inboxes/resetSecret',
        this.inbox.id
      );
      if (response) {
        useAlert(
          this.$t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.RESET_SUCCESS'
          )
        );
      } else {
        useAlert(
          this.$t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.RESET_ERROR'
          )
        );
      }
    },
    fetchSharedData() {
      this.$store.dispatch('agents/get');
      this.$store.dispatch('teams/get');
      this.$store.dispatch('labels/get');
    },
    syncInboxData() {
      if (!this.inbox || !this.inbox.id) return;

      this.selectedInboxName = this.inbox.name;
      this.webhookUrl = this.inbox.webhook_url;
      this.greetingEnabled = this.inbox.greeting_enabled || false;
      this.greetingMessage = this.inbox.greeting_message || '';
      this.emailCollectEnabled = this.inbox.enable_email_collect;
      this.senderNameType = this.inbox.sender_name_type;
      this.businessName = this.inbox.business_name;
      this.allowMessagesAfterResolved =
        this.inbox.allow_messages_after_resolved;
      this.continuityViaEmail = this.inbox.continuity_via_email;
      this.channelWebsiteUrl = this.inbox.website_url;
      this.channelWelcomeTitle = this.inbox.welcome_title;
      this.channelWelcomeTagline = this.inbox.welcome_tagline || '';
      this.channelChatInputText = this.inbox.chat_input_text || '';
      this.selectedFeatureFlags = (
        this.inbox.selected_feature_flags || []
      ).filter(f => f !== 'use_inbox_avatar_for_bot');
      this.replyTime = this.inbox.reply_time;

      const savedBubbleSettings = LocalStorage.get(
        this.widgetBuilderStorageKey
      );
      if (savedBubbleSettings) {
        this.widgetBubblePosition = savedBubbleSettings.position || 'right';
        this.widgetVerticalSpacing =
          savedBubbleSettings.verticalSpacing || 'standard';
        this.widgetHorizontalSpacing =
          savedBubbleSettings.horizontalSpacing || 'standard';
        this.widgetBubbleLauncherTitle =
          savedBubbleSettings.launcherTitle || '';
        this.widgetSize = savedBubbleSettings.widgetSize || 'medium';
        this.widgetDisplayOption =
          savedBubbleSettings.displayOption || 'mobile_and_desktop';
        this.bubbleIconStyle = savedBubbleSettings.launcherIconStyle || '1';
      } else {
        this.widgetBubblePosition = 'right';
        this.widgetVerticalSpacing = 'standard';
        this.widgetHorizontalSpacing = 'standard';
        this.widgetBubbleLauncherTitle = '';
        this.widgetSize = 'medium';
        this.widgetDisplayOption = 'mobile_and_desktop';
        this.bubbleIconStyle = this.inbox?.avatar_url
          ? CUSTOM_LAUNCHER_STYLE_ID
          : '1';
      }

      if (
        this.bubbleIconStyle === CUSTOM_LAUNCHER_STYLE_ID &&
        this.inbox?.avatar_url
      ) {
        this.customIconPreview = this.inbox.avatar_url;
      } else {
        this.customIconPreview = null;
      }
      this.customIconFile = null;

      if (this.headerLogoPreview?.startsWith('blob:')) {
        URL.revokeObjectURL(this.headerLogoPreview);
      }
      this.headerLogoPreview = this.inbox?.avatar_url || null;
      this.headerLogoFile = null;
      this.headerLogoRemoved = false;

      if (this.isAWebWidgetInbox) {
        this.syncWidgetPreviewPreChatFromInbox();
      }

      this.snapshotInboxSettings();

      this.$nextTick(() => {
        if (this.isAWebWidgetInbox) {
          this.snapshotWidgetCustomization();
        }
      });
    },
    getInboxSettingsSnapshot() {
      return {
        name: (this.selectedInboxName || '').trim(),
        webhookUrl: this.webhookUrl || '',
        emailCollectEnabled: this.emailCollectEnabled,
        allowMessagesAfterResolved: this.allowMessagesAfterResolved,
        greetingEnabled: this.greetingEnabled,
        greetingMessage: this.greetingMessage || '',
        senderNameType: this.senderNameType,
        businessName: this.businessName || '',
        continuityViaEmail: this.continuityViaEmail,
        replyTime: this.replyTime || '',
        selectedFeatureFlags: [...(this.selectedFeatureFlags || [])].sort(),
      };
    },
    snapshotInboxSettings() {
      this.savedInboxSettingsSnapshot = JSON.stringify(
        this.getInboxSettingsSnapshot()
      );
    },
    onWebWidgetConfigurationSaveStateChange({ canSave, isUpdating }) {
      this.webWidgetCanSave = canSave;
      this.webWidgetConfigurationLoading = isUpdating;
    },
    async onConfigurationSave() {
      if (this.selectedTabKey === 'configuration' && this.isAWebWidgetInbox) {
        await this.$refs.webWidgetConfigurationPage?.saveConfiguration();
        return;
      }
      await this.updateInbox();
    },
    syncWidgetPreviewPreChatFromInbox() {
      if (!this.inbox || !this.isAWebWidgetInbox) return;

      const customAttributes = this.$store.getters['attributes/getAttributes'];
      const {
        pre_chat_form_options: preChatFormOptions,
        pre_chat_form_enabled,
      } = this.inbox;
      const { pre_chat_message, pre_chat_fields } =
        getPreChatFields({
          preChatFormOptions,
          customAttributes,
        }) || {};

      this.widgetPreviewPreChat = {
        enabled: Boolean(pre_chat_form_enabled),
        message: pre_chat_message || '',
        fields: pre_chat_fields || [],
      };
    },
    getWidgetCustomizationSnapshot() {
      const sortedFlags = [...(this.selectedFeatureFlags || [])].sort();

      return {
        widgetColor: this.inbox?.widget_color || '',
        fontColor: this.inbox?.font_color || '',
        bubbleIconStyle: this.bubbleIconStyle,
        widgetBubbleLauncherTitle: this.widgetBubbleLauncherTitle || '',
        widgetSize: this.widgetSize,
        widgetDisplayOption: this.widgetDisplayOption,
        widgetBubblePosition: this.widgetBubblePosition,
        widgetVerticalSpacing: this.widgetVerticalSpacing,
        widgetHorizontalSpacing: this.widgetHorizontalSpacing,
        channelWelcomeTitle: this.channelWelcomeTitle || '',
        channelWelcomeTagline: this.channelWelcomeTagline || '',
        senderNameType: this.senderNameType,
        businessName: this.businessName || '',
        selectedFeatureFlags: sortedFlags.join(','),
        channelChatInputText: this.channelChatInputText || '',
        pendingAvatarUpload: Boolean(
          this.headerLogoFile || this.customIconFile
        ),
        pendingAvatarRemoval: Boolean(this.headerLogoRemoved),
        preChatFormEnabled: Boolean(this.widgetPreviewPreChat.enabled),
        preChatMessage: this.widgetPreviewPreChat.message || '',
        preChatFields: JSON.stringify(this.widgetPreviewPreChat.fields || []),
      };
    },
    snapshotWidgetCustomization() {
      if (!this.isAWebWidgetInbox) {
        this.savedWidgetCustomizationSnapshot = null;
        return;
      }

      this.savedWidgetCustomizationSnapshot = JSON.stringify(
        this.getWidgetCustomizationSnapshot()
      );
    },
    confirmDiscardWidgetChanges() {
      return this.$refs.unsavedChangesModal.showConfirmation();
    },
    async confirmLeaveWidgetCustomization() {
      if (
        !this.hasWidgetCustomizationChanges ||
        this.selectedTabKey !== 'widget-customization'
      ) {
        return true;
      }

      const confirmed = await this.confirmDiscardWidgetChanges();
      if (confirmed) {
        this.syncInboxData();
      }
      return confirmed;
    },
    onLauncherCustomIconSelected(file) {
      this.customIconFile = file;
    },
    onHeaderLogoSelected(file) {
      if (this.headerLogoPreview?.startsWith('blob:')) {
        URL.revokeObjectURL(this.headerLogoPreview);
      }
      this.headerLogoFile = file;
      this.headerLogoPreview = URL.createObjectURL(file);
      this.headerLogoRemoved = false;
    },
    onHeaderLogoRemoved() {
      if (this.headerLogoPreview?.startsWith('blob:')) {
        URL.revokeObjectURL(this.headerLogoPreview);
      }
      this.headerLogoPreview = null;
      this.headerLogoFile = null;
      this.headerLogoRemoved = true;
    },
    async fetchHealthData() {
      if (!this.inbox) return;

      if (!this.isAWhatsAppCloudChannel) {
        return;
      }

      try {
        this.isLoadingHealth = true;
        this.healthError = null;
        const response = await InboxHealthAPI.getHealthStatus(this.inbox.id);
        this.healthData = response.data;
      } catch (error) {
        this.healthError = error.message || 'Failed to fetch health data';
      } finally {
        this.isLoadingHealth = false;
      }
    },
    async registerWebhook() {
      if (!this.inbox) return;

      try {
        this.isRegisteringWebhook = true;
        await InboxHealthAPI.registerWebhook(this.inbox.id);
        useAlert(this.$t('INBOX_MGMT.ACCOUNT_HEALTH.WEBHOOK.REGISTER_SUCCESS'));
        await this.fetchHealthData();
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ACCOUNT_HEALTH.WEBHOOK.REGISTER_ERROR')
        );
      } finally {
        this.isRegisteringWebhook = false;
      }
    },
    handleFeatureFlag(e) {
      this.selectedFeatureFlags = this.toggleInput(
        this.selectedFeatureFlags,
        e.target.value
      );
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        const newSelectedFlags = selected.filter(flag => flag !== current);
        return newSelectedFlags;
      }
      return [...selected, current];
    },
    async onTabChange(selectedTabIndex) {
      const newTab = this.tabs[selectedTabIndex];
      if (
        this.selectedTabKey === 'widget-customization' &&
        newTab?.key !== 'widget-customization'
      ) {
        const canLeave = await this.confirmLeaveWidgetCustomization();
        if (!canLeave) return;
      }

      this.selectedTabIndex = selectedTabIndex;
      if (newTab?.key === 'widget-customization') {
        this.ensureWidgetSectionOpen();
      }
      this.updateRouteWithoutRefresh(selectedTabIndex);
    },
    updateRouteWithoutRefresh(selectedTabIndex) {
      const tab = this.tabs[selectedTabIndex];
      if (!tab) return;

      const { accountId, inboxId } = this.$route.params;
      const baseUrl = `/app/accounts/${accountId}/settings/channels/${inboxId}`;

      const defaultTabKey = this.isAWebWidgetInbox
        ? 'configuration'
        : 'inbox-settings';
      const newUrl =
        tab.key === defaultTabKey ? baseUrl : `${baseUrl}/${tab.key}`;
      // Update URL without triggering route watcher
      window.history.replaceState(null, '', newUrl);
    },
    setTabFromRouteParam() {
      const { tab: tabParam } = this.$route.params;
      if (!tabParam) {
        this.selectedTabIndex = 0;
        return;
      }
      let tabKey = tabParam;
      if (this.isAWebWidgetInbox && tabKey === 'pre-chat-form') {
        tabKey = 'widget-customization';
      }
      if (this.isBrowserWhatsappInbox && tabKey === 'login-account') {
        tabKey = 'configuration';
      }
      const tabIndex = this.tabs.findIndex(tab => tab.key === tabKey);
      this.selectedTabIndex = tabIndex === -1 ? 0 : tabIndex;
      if (this.selectedTabKey === 'widget-customization') {
        this.ensureWidgetSectionOpen();
      }
      if (this.isAWebWidgetInbox && tabParam === 'pre-chat-form') {
        this.$nextTick(() => {
          this.updateRouteWithoutRefresh(this.selectedTabIndex);
        });
      }
    },
    async updateInbox() {
      const bubbleSettings = {
        position: this.widgetBubblePosition,
        verticalSpacing: this.widgetVerticalSpacing,
        horizontalSpacing: this.widgetHorizontalSpacing,
        type: bubbleTypeFromPopupMessage(this.widgetBubbleLauncherTitle),
        launcherTitle: this.widgetBubbleLauncherTitle,
        launcherIconStyle: this.bubbleIconStyle,
        widgetSize: this.widgetSize,
        displayOption: this.widgetDisplayOption,
      };
      LocalStorage.set(this.widgetBuilderStorageKey, bubbleSettings);

      const shouldUploadLauncherIcon =
        this.customIconFile &&
        this.bubbleIconStyle === CUSTOM_LAUNCHER_STYLE_ID;
      let avatarFile = null;
      if (this.headerLogoFile) {
        avatarFile = this.headerLogoFile;
      } else if (shouldUploadLauncherIcon) {
        avatarFile = this.customIconFile;
      }
      const shouldUploadAvatar = Boolean(avatarFile);

      try {
        if (this.headerLogoRemoved && !avatarFile) {
          await this.$store.dispatch(
            'inboxes/deleteInboxAvatar',
            this.currentInboxId
          );
        }

        const isWidgetCustomizationSave =
          this.selectedTabKey === 'widget-customization';

        const channelPayload = {
          widget_color: this.inbox.widget_color,
          theme_color: this.inbox.widget_color,
          font_color: this.inbox.font_color,
          website_url: this.channelWebsiteUrl,
          webhook_url: this.webhookUrl,
          welcome_title: this.channelWelcomeTitle || '',
          welcome_tagline: this.channelWelcomeTagline || '',
          selectedFeatureFlags: this.selectedFeatureFlags,
          reply_time: this.replyTime || 'in_a_few_minutes',
          ...(isWidgetCustomizationSave
            ? {
                chat_input_text: this.channelChatInputText || '',
                pre_chat_form_enabled: this.widgetPreviewPreChat.enabled,
                pre_chat_form_options: {
                  pre_chat_message: this.widgetPreviewPreChat.message,
                  pre_chat_fields: this.widgetPreviewPreChat.fields,
                },
              }
            : {
                continuity_via_email: this.continuityViaEmail,
              }),
        };

        const payload = {
          id: this.currentInboxId,
          formData: shouldUploadAvatar,
          ...(shouldUploadAvatar ? { avatar: avatarFile } : {}),
          ...(isWidgetCustomizationSave
            ? {}
            : {
                name: this.selectedInboxName?.trim(),
                enable_email_collect: this.emailCollectEnabled,
                allow_messages_after_resolved: this.allowMessagesAfterResolved,
                greeting_enabled: this.greetingEnabled,
                greeting_message: this.greetingMessage || '',
                sender_name_type: this.senderNameType,
                business_name: this.businessName || null,
              }),
          channel: channelPayload,
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.customIconFile = null;
        this.headerLogoFile = null;
        this.headerLogoRemoved = false;
        this.snapshotWidgetCustomization();
        this.snapshotInboxSettings();
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
        this.showBusinessNameInput = false;
      } catch (error) {
        useAlert(error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    },
    toggleSenderNameType(key) {
      this.senderNameType = key;
    },
    onClickShowBusinessNameInput() {
      this.showBusinessNameInput = true;
      this.$nextTick(() => {
        this.$refs.businessNameInput?.focus();
      });
    },
    hideBusinessNameInput() {
      this.showBusinessNameInput = false;
    },
    ensureWidgetSectionOpen() {
      if (!this.openWidgetSection) {
        this.openWidgetSection = DEFAULT_OPEN_WIDGET_SECTION;
      }
    },
    toggleWidgetSection(section) {
      if (this.openWidgetSection === section) return;
      this.openWidgetSection = section;
    },
    onPreChatPreviewChange({ enabled, message, fields }) {
      this.widgetPreviewPreChat = {
        enabled,
        message,
        fields,
      };
    },
    goBackToChannelList() {
      this.$router.push({
        name: 'settings_inbox_list',
        params: { accountId: this.accountId },
      });
    },
  },
  validations: {
    webhookUrl: {
      shouldBeUrl,
    },
    selectedInboxName: {},
  },
};
</script>

<template>
  <div
    v-if="uiFlags.isFetching"
    class="flex items-center justify-center h-full w-full"
  >
    <SpinnerLoader :size="28" class="text-n-blue-9" />
  </div>
  <div
    v-else
    class="settings flex h-full min-h-0 w-full min-w-0 flex-1 flex-shrink flex-grow flex-col bg-n-surface-1 md:flex-row md:bg-transparent"
  >
    <aside
      class="flex w-full shrink-0 flex-col gap-3 overflow-visible border-n-weak px-3 pb-3 pt-3 md:h-full md:w-60 md:min-h-0 md:self-stretch md:border-e md:pb-3 md:pt-3"
      :aria-label="$t('INBOX_MGMT.SETTINGS_NAV.ARIA')"
    >
      <InboxSettingsInboxPicker
        :trigger-display-name="inboxName"
        :current-inbox-id="currentInboxId"
        :current-inbox="inbox"
      />
      <nav class="mt-2 flex min-h-0 flex-1 flex-col gap-0.5 overflow-y-auto">
        <InboxSettingsNavItem
          v-for="(tab, index) in tabs"
          :key="tab.key"
          :label="tab.name"
          :active="selectedTabIndex === index"
          @click="onTabChange(index)"
        />
      </nav>
      <div
        v-if="hasInboxConnectedBy"
        class="mt-auto mb-6 flex shrink-0 flex-col gap-0.5 text-start"
      >
        <p class="mb-0 text-sm font-medium leading-snug text-n-slate-12">
          {{ $t('INBOX_MGMT.SETTINGS_NAV.CONNECTED_BY') }}
        </p>
        <p class="mb-0 text-sm leading-snug text-black dark:text-white">
          {{ inboxConnectedByUserLine }}
        </p>
      </div>
    </aside>
    <section
      class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-n-surface-1 md:bg-n-solid-1"
    >
      <InboxSettingsPageHeader
        :title="configureHeaderTitle"
        :subtitle="$t('INBOX_MGMT.SETTINGS_LAYOUT.SUBTITLE')"
        :back-aria-label="$t('INBOX_MGMT.SETTINGS_LAYOUT.BACK_ARIA')"
        @back="goBackToChannelList"
      >
        <template
          v-if="selectedTabKey === 'widget-customization' && isAWebWidgetInbox"
          #actions
        >
          <NextButton
            variant="solid"
            color="blue"
            class="!h-7 min-h-7 !px-4 !text-sm font-medium"
            :disabled="v$.$invalid || !hasWidgetCustomizationChanges"
            :label="$t('INBOX_MGMT.SETTINGS_POPUP.SAVE_CHANGES')"
            :is-loading="uiFlags.isUpdating"
            @click="updateInbox"
          />
        </template>
      </InboxSettingsPageHeader>
      <div class="min-h-0 flex-1 overflow-y-auto">
        <div :class="mainContentWrapClass">
          <MicrosoftReauthorize
            v-if="microsoftUnauthorized"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <FacebookReauthorize
            v-if="facebookUnauthorized"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <GoogleReauthorize
            v-if="googleUnauthorized"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <InstagramReauthorize
            v-if="instagramUnauthorized"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <TiktokReauthorize
            v-if="tiktokUnauthorized"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <WhatsappReauthorize
            v-if="whatsappUnauthorized"
            :whatsapp-registration-incomplete="whatsappRegistrationIncomplete"
            :inbox="inbox"
            class="mb-4"
            :class="bannerMaxWidth"
          />
          <DuplicateInboxBanner
            v-if="hasDuplicateInstagramInbox"
            :content="$t('INBOX_MGMT.ADD.INSTAGRAM.DUPLICATE_INBOX_BANNER')"
            class="mb-4"
            :class="bannerMaxWidth"
          />

          <div
            v-if="
              selectedTabKey === 'widget-customization' && isAWebWidgetInbox
            "
            class="flex w-full flex-col gap-4 lg:flex-row lg:items-start lg:gap-6"
          >
            <div class="flex min-w-0 flex-1 flex-col">
              <WidgetCustomizationSection
                :title="
                  $t(
                    'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.DISPLAY_APPEARANCE'
                  )
                "
                :open="openWidgetSection === 'display'"
                @toggle="toggleWidgetSection('display')"
              >
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
                  <SettingsFieldSection
                    stacked
                    :label="
                      $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL')
                    "
                  >
                    <div class="justify-start">
                      <ColorPicker v-model="inbox.widget_color" />
                    </div>
                  </SettingsFieldSection>

                  <SettingsFieldSection stacked>
                    <template #label>
                      {{
                        $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.FONT_COLOR.LABEL')
                      }}
                      <Icon
                        v-tooltip.top="
                          $t(
                            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.FONT_COLOR.HELP_TEXT'
                          )
                        "
                        icon="i-lucide-info"
                        class="size-3.5 shrink-0 text-n-slate-10 cursor-help"
                      />
                    </template>
                    <div class="justify-start">
                      <ColorPicker v-model="inbox.font_color" />
                    </div>
                  </SettingsFieldSection>
                </div>

                <WebWidgetLauncherStylePicker
                  v-model="bubbleIconStyle"
                  v-model:custom-icon-preview="customIconPreview"
                  :widget-color="inbox.widget_color"
                  @custom-icon-selected="onLauncherCustomIconSelected"
                />

                <SettingsFieldSection
                  stacked
                  :label="
                    $t(
                      'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POPUP_MESSAGE.LABEL'
                    )
                  "
                  :help-text="
                    $t(
                      'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POPUP_MESSAGE.HELP_TEXT'
                    )
                  "
                >
                  <FormInput
                    v-model="widgetBubbleLauncherTitle"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POPUP_MESSAGE.PLACEHOLDER'
                      )
                    "
                  />
                </SettingsFieldSection>

                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
                  <SettingsFieldSection
                    stacked
                    :label="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.WIDGET_SIZE.LABEL'
                      )
                    "
                  >
                    <div class="w-full [&>div]:w-full [&_select]:w-full">
                      <SelectInput
                        v-model="widgetSize"
                        :options="[
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.WIDGET_SIZE.SMALL'
                            ),
                            value: 'small',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.WIDGET_SIZE.MEDIUM'
                            ),
                            value: 'medium',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.WIDGET_SIZE.LARGE'
                            ),
                            value: 'large',
                          },
                        ]"
                      />
                    </div>
                  </SettingsFieldSection>

                  <SettingsFieldSection
                    stacked
                    :label="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.DISPLAY_OPTIONS.LABEL'
                      )
                    "
                  >
                    <div class="w-full [&>div]:w-full [&_select]:w-full">
                      <SelectInput
                        v-model="widgetDisplayOption"
                        :options="[
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.DISPLAY_OPTIONS.MOBILE_AND_DESKTOP'
                            ),
                            value: 'mobile_and_desktop',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.DISPLAY_OPTIONS.DESKTOP_ONLY'
                            ),
                            value: 'desktop_only',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.DISPLAY_OPTIONS.MOBILE_ONLY'
                            ),
                            value: 'mobile_only',
                          },
                        ]"
                      />
                    </div>
                  </SettingsFieldSection>
                </div>
              </WidgetCustomizationSection>

              <WidgetCustomizationSection
                :title="$t('INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POSITION')"
                :open="openWidgetSection === 'position'"
                @toggle="toggleWidgetSection('position')"
              >
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-4">
                  <SettingsFieldSection
                    stacked
                    :label="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POSITION_SETTINGS.ALIGNMENT'
                      )
                    "
                  >
                    <div class="w-full [&>div]:w-full [&_select]:w-full">
                      <SelectInput
                        v-model="widgetBubblePosition"
                        :options="[
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.LEFT'
                            ),
                            value: 'left',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.RIGHT'
                            ),
                            value: 'right',
                          },
                        ]"
                      />
                    </div>
                  </SettingsFieldSection>

                  <SettingsFieldSection
                    stacked
                    :label="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POSITION_SETTINGS.VERTICAL_SPACING'
                      )
                    "
                  >
                    <div class="w-full [&>div]:w-full [&_select]:w-full">
                      <SelectInput
                        v-model="widgetVerticalSpacing"
                        :options="widgetSpacingSelectOptions"
                      />
                    </div>
                  </SettingsFieldSection>

                  <SettingsFieldSection
                    stacked
                    :label="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.POSITION_SETTINGS.HORIZONTAL_SPACING'
                      )
                    "
                  >
                    <div class="w-full [&>div]:w-full [&_select]:w-full">
                      <SelectInput
                        v-model="widgetHorizontalSpacing"
                        :options="widgetSpacingSelectOptions"
                      />
                    </div>
                  </SettingsFieldSection>
                </div>
              </WidgetCustomizationSection>

              <WidgetCustomizationSection
                :title="
                  $t('INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.HEADER_ELEMENTS')
                "
                :open="openWidgetSection === 'header'"
                @toggle="toggleWidgetSection('header')"
              >
                <div
                  class="flex flex-col gap-4 sm:flex-row sm:items-start sm:gap-6"
                >
                  <WebWidgetHeaderLogoPicker
                    :logo-preview="widgetPreviewHeaderLogo"
                    :name="channelWelcomeTitle || inbox?.name || ''"
                    @logo-selected="onHeaderLogoSelected"
                    @remove="onHeaderLogoRemoved"
                  />

                  <div class="flex min-w-0 flex-1 flex-col gap-4">
                    <SettingsFieldSection
                      stacked
                      :label="
                        $t(
                          'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.HEADER_TITLE.LABEL'
                        )
                      "
                    >
                      <FormInput
                        v-model="channelWelcomeTitle"
                        :placeholder="
                          $t(
                            'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.HEADER_TITLE.PLACEHOLDER'
                          )
                        "
                      />
                    </SettingsFieldSection>

                    <SettingsFieldSection
                      stacked
                      :label="
                        $t(
                          'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.HEADER_TAGLINE.LABEL'
                        )
                      "
                    >
                      <FormInput
                        v-model="channelWelcomeTagline"
                        :placeholder="
                          $t(
                            'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.HEADER_TAGLINE.PLACEHOLDER'
                          )
                        "
                      />
                    </SettingsFieldSection>
                  </div>
                </div>
              </WidgetCustomizationSection>

              <WidgetCustomizationSection
                :title="
                  $t('INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.PRE_CHAT_FORM')
                "
                :open="openWidgetSection === 'preChat'"
                @toggle="toggleWidgetSection('preChat')"
              >
                <PreChatFormSettings
                  :inbox="inbox"
                  embedded
                  in-accordion
                  @preview-change="onPreChatPreviewChange"
                />
              </WidgetCustomizationSection>

              <WidgetCustomizationSection
                :title="
                  $t(
                    'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.ADDITIONAL_SETTINGS'
                  )
                "
                :open="openWidgetSection === 'additional'"
                @toggle="toggleWidgetSection('additional')"
              >
                <SettingsFieldSection
                  stacked
                  :label="$t('INBOX_MGMT.FEATURES.LABEL')"
                >
                  <div class="flex flex-col gap-1 items-start">
                    <div class="flex gap-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="attachments"
                        @input="handleFeatureFlag"
                      />
                      <label for="attachments">
                        {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
                      </label>
                    </div>
                    <div class="flex gap-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="emoji_picker"
                        @input="handleFeatureFlag"
                      />
                      <label for="emoji_picker">
                        {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
                      </label>
                    </div>
                    <div class="flex gap-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="end_conversation"
                        @input="handleFeatureFlag"
                      />
                      <label for="end_conversation">
                        {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
                      </label>
                    </div>
                  </div>
                </SettingsFieldSection>

                <SettingsFieldSection
                  stacked
                  :label="
                    $t(
                      'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.INPUT_BAR_TEXT.LABEL'
                    )
                  "
                  :description="
                    $t(
                      'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.INPUT_BAR_TEXT.HELP_TEXT'
                    )
                  "
                >
                  <FormInput
                    v-model="channelChatInputText"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.WIDGET_CUSTOMIZATION_SECTIONS.INPUT_BAR_TEXT.PLACEHOLDER'
                      )
                    "
                  />
                </SettingsFieldSection>
              </WidgetCustomizationSection>
            </div>

            <div
              class="sticky top-4 w-full min-w-0 shrink-0 lg:w-[min(100%,28rem)] xl:w-[min(100%,32rem)]"
            >
              <div
                class="flex min-h-[45rem] w-full flex-col overflow-hidden rounded-2xl bg-n-surface-1 px-3 pt-3 pb-8 outline -outline-offset-1 outline-1 outline-n-weak"
              >
                <Widget
                  :welcome-heading="channelWelcomeTitle"
                  :welcome-tagline="channelWelcomeTagline"
                  :website-name="selectedInboxName"
                  :logo="widgetPreviewHeaderLogo"
                  :launcher-icon-style="bubbleIconStyle"
                  :launcher-custom-icon-url="widgetLauncherCustomIconUrl"
                  is-online
                  :color="inbox.widget_color"
                  :font-color="inbox.font_color"
                  :widget-bubble-position="widgetBubblePosition"
                  :widget-vertical-spacing="widgetVerticalSpacing"
                  :widget-horizontal-spacing="widgetHorizontalSpacing"
                  :widget-bubble-launcher-title="widgetBubbleLauncherTitle"
                  :widget-bubble-type="widgetBubbleType"
                  :widget-size="widgetSize"
                  :widget-display-option="widgetDisplayOption"
                  :pre-chat-form-enabled="widgetPreviewPreChat.enabled"
                  :pre-chat-message="widgetPreviewPreChat.message"
                  :pre-chat-fields="widgetPreviewPreChat.fields"
                  :selected-feature-flags="selectedFeatureFlags"
                  :chat-input-text="channelChatInputText"
                />
              </div>
            </div>
          </div>

          <div
            v-if="selectedTabKey === 'inbox-settings' && !isAWebWidgetInbox"
            class="w-full"
          >
            <div class="flex w-full min-w-0 flex-col">
              <InboxChannelConfigurationIdentity
                :inbox="inbox"
                :show-channel-name="false"
              />
              <SettingsFieldSection stacked :label="inboxNameLabel">
                <div class="flex flex-col gap-1">
                  <input
                    v-model="selectedInboxName"
                    type="text"
                    class="block w-full border-0 border-b bg-transparent px-0.5 py-2 text-sm text-n-slate-12 placeholder:text-n-slate-10 transition-colors focus:border-n-brand focus:outline-none focus:ring-0 dark:placeholder:text-n-slate-10"
                    :class="
                      v$.selectedInboxName.$error
                        ? 'border-n-ruby-8 focus:border-n-ruby-9'
                        : 'border-n-weak'
                    "
                    :placeholder="inboxNamePlaceHolder"
                    @blur="v$.selectedInboxName.$touch"
                  />
                  <p
                    v-if="v$.selectedInboxName.$error"
                    class="mb-0 text-label-small text-n-ruby-9"
                  >
                    {{ $t('INBOX_MGMT.ADD.CHANNEL_NAME.ERROR') }}
                  </p>
                </div>
              </SettingsFieldSection>
              <InboxConfigurationSaveBar
                v-if="isBrowserWhatsappInbox"
                :disabled="configurationSaveDisabled"
                :is-loading="configurationSaveLoading"
                @save="onConfigurationSave"
              />
              <BrowserWhatsappSessionPage
                v-if="isBrowserWhatsappInbox"
                :inbox="inbox"
                class="mb-6"
              />
              <SettingsFieldSection
                v-if="isAPIInbox && !isBrowserWhatsappInbox"
                :label="
                  $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.LABEL')
                "
              >
                <woot-input
                  v-model="webhookUrl"
                  class="[&>input]:!mb-0"
                  :class="{ error: v$.webhookUrl.$error }"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.PLACEHOLDER'
                    )
                  "
                  :error="
                    v$.webhookUrl.$error
                      ? $t(
                          'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.ERROR'
                        )
                      : ''
                  "
                  @blur="v$.webhookUrl.$touch"
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                v-if="isAPIInbox && !isBrowserWhatsappInbox && inbox.secret"
                :label="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.LABEL'
                  )
                "
              >
                <AccessToken
                  :value="inbox.secret"
                  @on-copy="copyWebhookSecret"
                  @on-reset="resetWebhookSecret"
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                v-if="isAWebWidgetInbox"
                :label="
                  $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.LABEL')
                "
              >
                <woot-input
                  v-model="channelWebsiteUrl"
                  class="[&>input]:!mb-0"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.PLACEHOLDER'
                    )
                  "
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                v-if="isAWhatsAppChannel"
                :label="$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL')"
              >
                <input
                  v-model="whatsAppAPIProviderName"
                  type="text"
                  disabled
                  class="!mb-0"
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                v-if="isAWebWidgetInbox || isAnEmailChannel"
                :label="$t('INBOX_MGMT.EDIT.SENDER_NAME_SECTION.TITLE')"
                class="[&>div>div]:justify-end [&>div>div]:flex lg:[&>div:first-child]:h-12 [&>div:first-child]:h-16"
              >
                <NextButton
                  v-if="!showBusinessNameInput"
                  ghost
                  blue
                  sm
                  :label="
                    $t(
                      'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.BUTTON_TEXT'
                    )
                  "
                  @click="onClickShowBusinessNameInput"
                />

                <div
                  v-if="showBusinessNameInput"
                  v-on-clickaway="hideBusinessNameInput"
                  class="flex justify-end gap-2 w-full"
                >
                  <input
                    ref="businessNameInput"
                    v-model="businessName"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.PLACEHOLDER'
                      )
                    "
                    class="!mb-0"
                    type="text"
                  />
                  <NextButton
                    :label="
                      $t(
                        'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.SAVE_BUTTON_TEXT'
                      )
                    "
                    class="flex-shrink-0"
                    @click="updateInbox"
                  />
                </div>

                <template #extra>
                  <SenderNameExamplePreview
                    :sender-name-type="senderNameType"
                    :business-name="businessName"
                    :is-website-channel="isAWebWidgetInbox"
                    @update="toggleSenderNameType"
                  />
                </template>
              </SettingsFieldSection>

              <SettingsAccordion
                v-if="isAWebWidgetInbox"
                :title="$t('INBOX_MGMT.WIDGET_FEATURES')"
                class="mt-6"
              >
                <SettingsFieldSection
                  :label="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.LABEL'
                    )
                  "
                >
                  <woot-input
                    v-model="channelWelcomeTitle"
                    class="[&>input]:!mb-0"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.PLACEHOLDER'
                      )
                    "
                  />
                </SettingsFieldSection>

                <SettingsFieldSection
                  :label="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.LABEL'
                    )
                  "
                  class="[&>div]:!items-start [&>div>label]:mt-1"
                >
                  <Editor
                    v-model="channelWelcomeTagline"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.PLACEHOLDER'
                      )
                    "
                    :max-length="255"
                    channel-type="Context::InboxSettings"
                  />
                </SettingsFieldSection>

                <SettingsFieldSection
                  :label="
                    $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL')
                  "
                >
                  <div class="justify-start">
                    <ColorPicker v-model="inbox.widget_color" />
                  </div>
                </SettingsFieldSection>
                <SettingsFieldSection
                  :label="
                    $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE')
                  "
                >
                  <div class="flex items-center gap-6">
                    <div class="flex items-center gap-2">
                      <label class="text-n-slate-11 text-heading-3">
                        {{
                          $t(
                            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION_LABEL'
                          )
                        }}
                      </label>
                      <SelectInput
                        v-model="widgetBubblePosition"
                        :options="[
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.LEFT'
                            ),
                            value: 'left',
                          },
                          {
                            label: $t(
                              'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.RIGHT'
                            ),
                            value: 'right',
                          },
                        ]"
                        class="[&>select]:!p-0 min-w-16 [&>select]:!outline-none"
                      />
                    </div>
                  </div>
                </SettingsFieldSection>

                <SettingsFieldSection
                  :label="
                    $t(
                      'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.LABEL'
                    )
                  "
                >
                  <woot-input
                    v-model="widgetBubbleLauncherTitle"
                    :placeholder="
                      $t(
                        'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.PLACE_HOLDER'
                      )
                    "
                    class="[&>input]:!mb-0"
                  />
                </SettingsFieldSection>

                <SettingsFieldSection
                  :label="$t('INBOX_MGMT.FEATURES.LABEL')"
                  class="[&>div]:!items-start [&>div>label]:mt-2"
                >
                  <div class="flex flex-col gap-1 items-start">
                    <div class="flex gap-2 pt-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="attachments"
                        @input="handleFeatureFlag"
                      />
                      <label for="attachments">
                        {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
                      </label>
                    </div>
                    <div class="flex gap-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="emoji_picker"
                        @input="handleFeatureFlag"
                      />
                      <label for="emoji_picker">
                        {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
                      </label>
                    </div>
                    <div class="flex gap-2 py-0.5">
                      <input
                        v-model="selectedFeatureFlags"
                        type="checkbox"
                        value="end_conversation"
                        @input="handleFeatureFlag"
                      />
                      <label for="end_conversation">
                        {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
                      </label>
                    </div>
                  </div>
                </SettingsFieldSection>
              </SettingsAccordion>

              <SettingsAccordion
                v-if="!isBrowserWhatsappInbox"
                :title="$t('INBOX_MGMT.CHANNEL_PREFERENCES')"
                class="mt-6"
              >
                <SettingsToggleSection
                  v-if="!isBrowserWhatsappInbox"
                  v-model="greetingEnabled"
                  :header="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.LABEL'
                    )
                  "
                  :description="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.HELP_TEXT'
                    )
                  "
                >
                  <template v-if="greetingEnabled" #editor>
                    <GreetingsEditor
                      v-model="greetingMessage"
                      :label="
                        $t(
                          'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.LABEL'
                        )
                      "
                      :placeholder="
                        $t(
                          'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.PLACEHOLDER'
                        )
                      "
                      :richtext="!textAreaChannels"
                    />
                  </template>
                </SettingsToggleSection>

                <SettingsToggleSection
                  v-if="isAWebWidgetInbox"
                  v-model="emailCollectEnabled"
                  :header="
                    $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX')
                  "
                  :description="
                    $t(
                      'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT'
                    )
                  "
                />

                <SettingsToggleSection
                  v-if="isAWebWidgetInbox"
                  v-model="allowMessagesAfterResolved"
                  :header="
                    $t(
                      'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED'
                    )
                  "
                  :description="
                    $t(
                      'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT'
                    )
                  "
                />

                <SettingsToggleSection
                  v-if="isAWebWidgetInbox"
                  v-model="continuityViaEmail"
                  :header="
                    $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL')
                  "
                  :description="
                    $t(
                      'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT'
                    )
                  "
                />
              </SettingsAccordion>
            </div>

            <div
              v-if="isAWebWidgetInbox"
              class="flex-1 sticky top-4 self-start max-w-lg flex-shrink-0 w-full min-w-0"
            >
              <div
                class="flex flex-col outline -outline-offset-1 outline-1 outline-n-weak w-full px-3 pt-3 pb-8 bg-n-surface-1 rounded-2xl min-h-[45rem] overflow-hidden"
              >
                <Widget
                  :welcome-heading="channelWelcomeTitle"
                  :welcome-tagline="channelWelcomeTagline"
                  :website-name="selectedInboxName"
                  :logo="widgetPreviewHeaderLogo"
                  :launcher-icon-style="bubbleIconStyle"
                  :launcher-custom-icon-url="widgetLauncherCustomIconUrl"
                  is-online
                  :color="inbox.widget_color"
                  :font-color="inbox.font_color"
                  :widget-bubble-position="widgetBubblePosition"
                  :widget-vertical-spacing="widgetVerticalSpacing"
                  :widget-horizontal-spacing="widgetHorizontalSpacing"
                  :widget-bubble-launcher-title="widgetBubbleLauncherTitle"
                  :widget-bubble-type="widgetBubbleType"
                  :widget-size="widgetSize"
                  :widget-display-option="widgetDisplayOption"
                  :pre-chat-form-enabled="widgetPreviewPreChat.enabled"
                  :pre-chat-message="widgetPreviewPreChat.message"
                  :pre-chat-fields="widgetPreviewPreChat.fields"
                  :selected-feature-flags="selectedFeatureFlags"
                  :chat-input-text="channelChatInputText"
                />
              </div>
            </div>
          </div>

          <div v-if="selectedTabKey === 'configuration'" class="w-full">
            <WebWidgetConfigurationPage
              v-if="isAWebWidgetInbox"
              ref="webWidgetConfigurationPage"
              :inbox="inbox"
              @save-state-change="onWebWidgetConfigurationSaveStateChange"
            />
            <ConfigurationPage v-else :inbox="inbox" />
          </div>
          <div
            v-if="selectedTabKey === 'message-templates'"
            :class="bannerMaxWidth"
          >
            <InboxMessageTemplatesTab :inbox="inbox" />
          </div>
          <div
            v-if="selectedTabKey === 'business-hours'"
            :class="bannerMaxWidth"
          >
            <InboxBusinessHoursTab :inbox="inbox" />
          </div>
          <div v-if="selectedTabKey === 'pre-chat-form' && !isAWebWidgetInbox">
            <PreChatFormSettings :inbox="inbox" />
          </div>
          <div v-if="selectedTabKey === 'whatsapp-health'">
            <AccountHealth
              :health-data="healthData"
              :is-registering-webhook="isRegisteringWebhook"
              @register-webhook="registerWebhook"
            />
          </div>
          <div v-if="selectedTabKey === 'troubleshoot'">
            <InboxTroubleshootPage
              :inbox="inbox"
              :whatsapp-registration-incomplete="whatsappRegistrationIncomplete"
            />
          </div>

          <InboxConfigurationSaveBar
            v-if="showConfigurationSaveBar"
            :disabled="configurationSaveDisabled"
            :is-loading="configurationSaveLoading"
            @save="onConfigurationSave"
          />
          <InboxDangerZone
            v-if="inbox?.id && selectedTabIndex === 0"
            :inbox="inbox"
          />
        </div>
      </div>
    </section>
    <ConfirmationModal
      ref="unsavedChangesModal"
      :title="$t('INBOX_MGMT.SETTINGS_POPUP.UNSAVED_CHANGES_TITLE')"
      :description="$t('INBOX_MGMT.SETTINGS_POPUP.UNSAVED_CHANGES_MESSAGE')"
      :confirm-label="$t('INBOX_MGMT.SETTINGS_POPUP.UNSAVED_CHANGES_CONFIRM')"
      :cancel-label="$t('INBOX_MGMT.SETTINGS_POPUP.UNSAVED_CHANGES_CANCEL')"
    />
  </div>
</template>
